import { OpiApi } from "../../configs/appRoute";
import { AxiosAuth } from "../../core/Axios/AxiosInstance";
import type { Dispatch } from "@reduxjs/toolkit";
import { ActionInterpreterScript } from "../../core/Redux/Slices/sliceInterpreterScript";


export const requestInterpreterScript = (callerId?: string) => async (
  dispatch: Dispatch,
): Promise<void> => {
  if (!callerId?.trim()) return;
  // Refresh on every call, even when this caller already has a stored result.
  dispatch(ActionInterpreterScript.FetchStart(callerId));
  try {
    const res = await AxiosAuth.get(OpiApi.CustomInput.GetInterpreterScript(callerId));
    const result = res?.data?.data;
    if (res.status !== 200 || res.data?.isSuccess !== true ||
        typeof result?.isEnabled !== "boolean" ||
        (result.isEnabled && typeof result.script !== "string")) {
      throw new Error("Failed to load interpreter script.");
    }
    dispatch(ActionInterpreterScript.FetchSuccess({
      callerId,
      isEnabled: result.isEnabled,
      script: result.isEnabled ? result.script : "",
    }));
  } catch (error: any) {
    dispatch(ActionInterpreterScript.FetchFailure({
      callerId,
      error: error?.message || "Failed to load interpreter script.",
    }));
  }
};
